import XHeader from 'vux/src/components/x-header/index.vue'
import Step from 'vux/src/components/step/step.vue'
import StepItem from 'vux/src/components/step/step-item.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Icon from 'vux/src/components/icon/index.vue'


import * as $ from 'jquery'
import plupload from 'plupload'
import common from '../../common/common.js'



export default {
name:'monthly',
components: {
XHeader, Step, StepItem, Group, XInput, Cell, CheckIcon, XButton, Popup, Checklist, Icon,
},
data () {
return {

stepShow:false,//申请进度
step: 0,
stepText:'完成',
underReview:false,//审核中
agreement: false,//用户协议
monthlyPopup:false,//月结周期
monthlyMoneyPopup :false,//月结金额
reject:false,//审核不通过
rejectCause:'',//不通过原因


monthlyTimeList: ['一个月'],
monthlyTimeSelected: ['一个月'],


monthlyMoneyList: [],
monthlyMoneySelected: [],

name:'',
companyName:'',//公司名
address:'',
bankAccount:'',//银行账号
phone:'',
period:'一个月',//周期
money:'',
IDcartFront:require('../../assets/images/IDcartZ.png'),
IDcartReverseSide:require('../../assets/images/IDcartF.png'),
license:require('../../assets/images/license.png'),//营业执照





}
},
methods: {


getMoney() {
this.$request.post('/monthlyKonts/listAmount',{ token:common.getCookie('_token'), }).then((response)=>{
console.log(response);
if(response.code == 0) {
for(let i=0; i<response.obj.length; i++) {
this.monthlyMoneyList.push(response.obj[i].dictValue);
}
this.monthlyMoneySelected.push(response.obj[0].dictValue)
this.money = response.obj[0].dictValue;
}
})
},


getApplyInfo(){
this.$request.post('/monthlyKonts/getMonthlyKnots',{token:common.getCookie('_token')}).then((response)=>{
console.log(response);
if(response.code == 0) {


if(response.obj == null || response.obj.monthlyKnotsApply == null) {
this.stepShow = true;
}else if(response.obj.monthlyKnotsApply == '提交') {//审核中
this.stepShow = false;

this.underReview = true;
}else if(response.obj.monthlyKnotsApply == '审核未通过') {
this.stepShow = true;
this.stepText = '驳回';
this.rejectCause = response.obj.remark;
this.reject = true;
this.step = 3;


this.name = response.obj.realName
this.companyName = response.obj.corporateName
this.address = response.obj.corporateAddress
this.bankAccount = response.obj.corporateBankAccount
this.phone = response.obj.corporateContacts
this.period = response.obj.cycle
this.money = response.obj.capAmount
this.IDcartFront = response.obj.certificatesPositivePhoto
this.IDcartReverseSide = response.obj.certificatesBackPhoto
this.license = response.obj.businessLicense
}else if(response.obj.monthlyKnotsApply == '审核') {

this.stepShow = true;
this.step = 3;

this.name = response.obj.realName
this.companyName = response.obj.corporateName
this.address = response.obj.corporateAddress
this.bankAccount = response.obj.corporateBankAccount
this.phone = response.obj.corporateContacts
this.period = response.obj.cycle
this.money = response.obj.capAmount
this.IDcartFront = response.obj.certificatesPositivePhoto
this.IDcartReverseSide = response.obj.certificatesBackPhoto
this.license = response.obj.businessLicense
}


}else{
this.$vux.toast.show({
type: 'warn',
text: response.msg
})
}
})
},

moneyChange(val, label){
this.monthlyMoneyPopup = false
this.money = label[0];
},



upFile(url,browseButton,container) {

console.log(common.getCookie('_token'))


this.$request.post(url,{'token':common.getCookie('_token')})
.then((response) => {
console.log(response);
if (response.code == 0) {




$('.moxie-shim-html5').remove();
var obj = response.obj


var accessid = ''
var accesskey = ''
var host = ''
var policyBase64 = ''
var signature = ''
var callbackbody = ''
var filename = ''
var key = ''
var expire = 0
var g_object_name = ''
var g_object_name_type = ''
var timestamp = Date.parse(new Date()) / 1000;
var now = timestamp;

function check_object_radio() {
var tt = document.getElementsByName('myradio');
for (var i = 0; i < tt.length; i++) {
if (tt[i].checked) {
g_object_name_type = tt[i].value;
break;
}
}
}

function get_signature() {

now = timestamp = Date.parse(new Date()) / 1000;
if (expire < now + 3) {





host = obj['host']

policyBase64 = obj['policy']
accessid = obj['accessid']
signature = obj['signature']
expire = parseInt(obj['expire'])
callbackbody = obj['callback']
key = obj['dir']


return true;
}
return false;
};

function random_string(len) {
len = len || 32;
var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
var maxPos = chars.length;
var pwd = '';
for (let i = 0; i < len; i++) {
pwd += chars.charAt(Math.floor(Math.random() * maxPos));
}
return pwd;
}

function get_suffix(filename) {
let pos = filename.lastIndexOf('.')
let suffix = ''
if (pos != -1) {
suffix = filename.substring(pos)
}
return suffix;
}

function calculate_object_name(filename) {
if (g_object_name_type == 'local_name') {
g_object_name += "${filename}"
}
else if (g_object_name_type == 'random_name') {
let suffix = get_suffix(filename)
g_object_name = key + random_string(10) + suffix
}
return ''
}

function get_uploaded_object_name(filename) {
if (g_object_name_type == 'local_name') {
let tmp_name = g_object_name
tmp_name = tmp_name.replace("${filename}", filename);
return tmp_name
}
else if (g_object_name_type == 'random_name') {
return g_object_name
}
}

function set_upload_param(up, filename, ret) {
if (ret == false) {
ret = get_signature()
}
g_object_name = key;
if (filename != '') {
let suffix = get_suffix(filename)
calculate_object_name(filename)
}
let new_multipart_params = {
'key': g_object_name,
'policy': policyBase64,
'OSSAccessKeyId': accessid,
'success_action_status': '200', //让服务端返回200,不然，默认会返回204

'signature': signature,
};

up.setOption({
'url': host,
'multipart_params': new_multipart_params
});

up.start();
}

var uploader = new plupload.Uploader({
runtimes: 'html5,flash,silverlight,html4',

browse_button: browseButton,
multi_selection: false,

container: document.getElementById(container),
flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
url: 'http://oss.aliyuncs.com',

filters: {
mime_types: [ //只允许上传图片和zip文件和stl文件



],
max_file_size: '100mb', //最大只能上传100mb的文件
prevent_duplicates: false
},

max_retries: 3, //请求错误时的重试次数，为0时表示不重试

init: {
PostInit:()=> {
document.getElementById('ossfile').innerHTML = '';




},

FilesAdded:  (up, files)=> {
set_upload_param(uploader, '', false);
plupload.each(files,  (file)=> {
document.getElementById('ossfile').innerHTML += '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ')<b></b>'
+ '<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>'
+ '</div>';
});
},

BeforeUpload: function (up, file) {
check_object_radio();
set_upload_param(up, file.name, true);

},

UploadProgress:  (up, file)=> {


var d = document.getElementById(file.id);
d.getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
var prog = d.getElementsByTagName('div')[0];

var progBar = prog.getElementsByTagName('div')[0]

progBar.style.width = 2 * file.percent + 'px';
progBar.setAttribute('aria-valuenow', file.percent);

},

FileUploaded:  (up, file, info) =>{
if (info.status == 200) {



var ossPath = host + '/' + get_uploaded_object_name(file.name);
console.log(ossPath)

if(browseButton == 'IDcartFront') {
this.IDcartFront = ossPath

}

if(browseButton == 'IDcartReverseSide') {
this.IDcartReverseSide = ossPath;

}

if(browseButton == 'license') {
this.license = ossPath;

}



}
},

Error: function (up, err) {
console.log('出现错误');
if (err.code == -600) {
document.getElementById('console').appendChild(document.createTextNode("\n选择的文件太大了,可以根据应用情况，在upload.js 设置一下上传的最大大小"));
}
else if (err.code == -601) {
document.getElementById('console').appendChild(document.createTextNode("\n选择的文件后缀不对,可以根据应用情况，在upload.js进行设置可允许的上传文件类型"));
}
else if (err.code == -602) {
document.getElementById('console').appendChild(document.createTextNode("\n这个文件已经上传过一遍了"));
}
else {
document.getElementById('console').appendChild(document.createTextNode("\nError xml:" + err.response));
}
}
}
});


uploader.init();
}
else {
return;
}
})
},


applyfor(){






if(this.name == '' || this.companyName == '' || this.address == '' || this.bankAccount == ''|| this.period==''|| this.money == '') {
this.$vux.toast.show({
type: 'warn',
text: '请填写信息'
})
return false;
}

if(this.IDcartFront.split(':')[0] != 'https' || this.IDcartReverseSide.split(':')[0] != 'https') {
this.$vux.toast.show({
type: 'warn',
text: '请上传身份证'
})
return false;
}

if(this.license.split(':')[0] != 'https') {
this.$vux.toast.show({
type: 'warn',
text: '请上传营业执照'
})
return false;
}

if(this.agreement == false) {
this.$vux.toast.show({
type: 'warn',
text: '请阅读用户协议'
})
return false;
}


this.$request.post('/monthlyKonts/monthlyKnotsApply',{

token: common.getCookie('_token'), //用户token
realName: this.name, //姓名
corporateName: this.companyName, //公司名称
corporateAddress: this.address, //公司办公地址
corporateBankAccount: this.bankAccount, //公司银行账号
corporateContacts: this.phone, //公司联系电话
cycle: this.period, //申请月结周期
capAmount: this.money, //申请月结金额上限
certificatesPositivePhoto: this.IDcartFront, //证件正面照
certificatesBackPhoto: this.IDcartReverseSide, //证件反面照
businessLicense: this.license, //公司营业执照
}).then((response)=>{
console.log(response);
if(response.code == 0) {
this.stepShow = false;
this.underReview = true;
this.reject = false;
}else{
this.$vux.toast.show({
type: 'warn',
text: response.msg
})
}
})
},


underReviewConfirm(){
this.$router.push('/');
},



},
created() {
this.getMoney()
this.getApplyInfo()
console.log(common.getCookie('_token'))
},
}


// WEBPACK FOOTER //
// ./src/views/monthly/script.js